import { selectedMusic, itemToMusicTime, musicToItemTime } from './project.js';

export const COUNTDOWN_INPUTS = Object.freeze({ countdownTouch: 'Touch, click & keyboard', countdownVoice: 'Voice commands', countdownHand: 'Hand gestures', countdownFace: 'Face, eye & mouth gestures', countdownLoop: 'Automatic loops' });
export function countdownInput(command = {}) {
  if (command.source === 'loop') return 'countdownLoop';
  if (command.source === 'voice') return 'countdownVoice';
  if (['eyes', 'mouth'].includes(command.source)) return 'countdownFace';
  if (command.source === 'gesture') return ['palm', 'shush'].includes(command.gesture) ? 'countdownHand' : 'countdownFace';
  return 'countdownTouch';
}
export function countdownInterval(item, time, rate, fallbackBpm = 120) {
  const music = selectedMusic(item), musicTime = itemToMusicTime(item, time, music);
  const tempo = music?.tempos?.filter(tempo => tempo.time <= musicTime).at(-1) ?? music?.tempos?.[0];
  const bpm = tempo?.bpm || fallbackBpm;
  const beat = 60 / bpm;
  const duration = tempo ? musicToItemTime(item, musicTime + beat, music) - musicToItemTime(item, musicTime, music) : beat;
  return duration * 1000 / rate;
}
